// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FXP1E","content":"styles_content__z90AJ"};